import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import { GatsbyImage } from 'gatsby-plugin-image'
import { resolveAsImage } from '@algbra/ui/resolvers'
import styles from "./ImageRibbon.module.scss"

export type ZoneImageRibbonProps = {
  __typename: 'StrapiGQL_ComponentZonesImageRibbon'
  image: GatsbyResolvedAsset
}
export default function ZoneImageRibbon(props: ZoneImageRibbonProps) {
  return (
    <Whitespace type="md" hasAnimation={false}>
      <GatsbyImage image={resolveAsImage(props.image)} alt="" className={styles.ribbon} />
    </Whitespace>
  )
}
